import { publicListingPath } from '@mts/shared/publicListingUrls';

export function getListingCategorySlug(listing = {}) {
  const assignedSlugs = (listing.listingCategories || []).map(row => row?.tenantCategory?.slug || row?.category?.slug).filter(Boolean).map(String).sort();
  if (assignedSlugs.length) return assignedSlugs[0];
  const raw = listing?.listingCategories?.[0]?.tenantCategory?.slug
    || listing?.listingCategories?.[0]?.category?.slug
    || listing?.listingCategories?.[0]?.tenantCategory?.name
    || listing?.listingCategories?.[0]?.category?.name
    || listing?.primaryCategory?.slug
    || listing?.primaryCategory?.name
    || listing?.category?.slug
    || listing?.category?.name
    || listing?.category
    || 'uncategorized';

  return String(raw)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '') || 'uncategorized';
}

export function buildListingPath(listing = {}) {
  const publicUrl = String(
    listing?.listingURL
    || listing?.listingUrl
    || listing?.publicUrl
    || listing?.publicPath
    || ''
  ).trim();
  if (publicUrl) return publicUrl;

  const slug = String(listing?.slug || '').trim();
  if (!slug) return '';

  if (listing.listingCategories?.some(row => row?.tenantCategory?.slug) || !(listing.category || listing.primaryCategory || listing.listingCategories?.length)) return publicListingPath(listing);
  const categorySlug = getListingCategorySlug(listing);
  return `/listings/${encodeURIComponent(categorySlug)}/${encodeURIComponent(slug)}`;
}
